/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import { Application as AppEnum } from '@fides/fides-react-components';
import { ENV } from 'core/consts';
import { Environment } from 'core/enums';
import { Application } from 'core/models';
import moment from 'moment';
import { JsonObject } from '../types';

export const formatDate = (date: string, format = 'DD.MM.YYYY hh:mm:ss'): string => moment(date).format(format);

export const formatUnixTimestamp = (unixTimestamp: number, format = 'DD.MM.YYYY hh:mm:ss'): string => {
  const seconds = Math.floor(unixTimestamp);
  const milliseconds = Math.round((unixTimestamp - seconds) * 1000);
  const totalMilliseconds = seconds * 1000 + milliseconds;
  return moment(totalMilliseconds).format(format);
};

export const redirectToExternalURL = (url: string, id?: string): void => {
  const goToUrl = id ? `${url}?id=${id}` : url;
  window.location.href = goToUrl;
};

export const getAppUrl = (appName: AppEnum, appList: Application[]): string | undefined =>
  appList.find((item: Application) => (item.name as string) === appName)?.url;

export const isLocalEnv: boolean = ENV.ENVIRONMENT === Environment.LOCAL;

export const isImpersonatedUser = (json: JsonObject): boolean => json.impersonated && json.impersonatedUser !== null;

export const replaceEmptyStringsWithNulls = (object: JsonObject): JsonObject => {
  if (Array.isArray(object)) {
    return object.map((item) => replaceEmptyStringsWithNulls(item));
  }

  if (object !== null && typeof object === 'object') {
    const transformedValues = {};

    Object.keys(object).forEach((key) => {
      if (typeof object[key] === 'string' && object[key] === '') {
        transformedValues[key] = null;
      } else {
        transformedValues[key] = replaceEmptyStringsWithNulls(object[key]);
      }
    });

    return transformedValues;
  }

  return object;
};

const setNestedValue = (obj: any, path: string, value: boolean) => {
  const keys = path.split('.');
  let current = obj;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      current[key] = current[key] || {};
      current = current[key];
    }
  });
};

export const extractLockedFields = (obj: any, parentKey = '', result: any = {}) => {
  if (obj && typeof obj === 'object') {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (key.endsWith('Locked') && typeof value === 'boolean') {
        setNestedValue(result, parentKey ? `${parentKey}.${key}` : key, value);
      } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        extractLockedFields(value, parentKey ? `${parentKey}.${key}` : key, result);
      }
    });
  }
  return result;
};

export const formatIsoString = (isoInput: string | Date, format = 'DD.MM.YYYY hh:mm:ss'): string => {
  return moment(isoInput).format(format);
};
